<app-dialog [header]="header" [show]="!(hideSelf$ | async)" [hideHeaderUnderline]="hideHeaderUnderline" [id]="dialogId" [minWidth]="850">
    <ng-content select="[subHeader]"></ng-content>
    <form [formGroup]="dialogForm" class="table-scroll-wrapper main-scroll-default drug-form-container"
    (ngSubmit)="validate()">
        <app-input-search-scanner 
            [autofocus]="true"
            [isInventory]="limitDrugSearchToPharmacy"
            (optionSelected)="optionSelected($event)"
            (searchCleared)="drugSearchCleared()"
            (keydownTab)="dialogForm?.get('friendlyName')?.value ? focusInput('rxNumberInput') : focusButton('closeButton')"
            [placeholder]="'Scan barcode (Or search drug name or NDC)'"
            [label]="drugScannerLabel"
            [errorMessage]="drugSearchErrorMessage"
            [active]="true"
            [searchEmptyInventory]="false"
            [displayError]="forceDrugSearchError"
            [singleLocationResult]="searchSingleLocation"
            [locationsToExclude]="getLocationsToExclude()"
            [searchBothCustomAndFdaDrugs]="true"
            [gpi]="gpi"
            #searchScanner
            *ngIf="addDrugMode || !dialogForm.controls.drugs?.value?.length"
        ></app-input-search-scanner>
        <div *ngIf="!addDrugMode && dialogForm.controls.drugs?.value?.length">
            <div class="form-row !border-b-0 !pt-0 !pb-0">
                <app-input *ngIf="typesForDispenseModal.includes(dialogType)"
                        class="custom-input"
                        [label]="'Rx Number'"
                        (keyupEnter)="onRxNumberInputTabEnterKeyDown()"
                        (keydownTab)="onRxNumberInputTabEnterKeyDown()"
                        formControlName="rxNumber"
                        #rxNumberInput 
                ></app-input>
                <app-input *ngIf="typesForDispenseModal.includes(dialogType) && enableC3toC5Drugs$ | async"
                    class="custom-input !w-[26%]"
                    label="Fill #"
                    errorRequiredMessage="Required"
                    (keyupEnter)="focusInput('patientNameInput')"
                    (keydownTab)="focusInput('patientNameInput')"
                    formControlName="fillNumber"
                    type="number"
                    #fillNumberInput 
                ></app-input>
                <app-input *ngIf="typesForDispenseModal.includes(dialogType)"
                        class="custom-input"
                        [label]="'Patient Name'"
                        (keyupEnter)="transactionDatePicker.focusInput()"
                        formControlName="patientName"
                        type="textUpperCase"
                        #patientNameInput
                ></app-input>
                <div class="optional-row" *ngIf="withDescription()">
                    <app-input
                        [label]="descriptionLabel"
                        [optional]="true"
                        (keyupEnter)="transactionDatePicker.focusInput()"
                        formControlName="description"
                        #descriptionInput
                    ></app-input>
                </div>
                <app-datepicker-input [tabInd]="0"
                    class="ml-[8px]"
                    label="Transaction Date/Time"
                    pickerType="both"
                    formControlName="transactionDateDisplayValue"
                    (dateTimeChange)="dateTimeChanged($event)"
                    (inputTabKeyDown)="transactionDatePickerKeyDown()"
                    [dateMax]="now()"
                    calendarPosition="right"
                    #transactionDatePicker>
                </app-datepicker-input>
            </div>

            <table class="table-primary">
                <thead>
                    <tr>
                        <th class="text-left drug" scope="col">
                            Drug
                        </th>
                        <th class="text-left location" scope="col" *ngIf="inventoryLocationsEnabled$ | async">
                            {{getInputLocationColumnHeader()}}
                        </th>
                        <th class="text-right starting" scope="col">
                            Starting
                        </th>
                        <th class="text-right count" scope="col">
                            Count
                        </th>
                        <th class="text-right on-hand" scope="col">
                            On-Hand
                        </th>
                        <th class="text-right on-hand !pl-0" scope="col">
                            SOH
                        </th>
                        <th class="text-left back-count" scope="col" *ngIf="backCountService.isAnyRequiresBackCount()">
                            BACK-COUNT OK?
                        </th>
                        <th class="controls"></th>
                    </tr>
                </thead>
                <tbody cdk-scrollable>
                    <ng-container formArrayName="drugs" *ngFor="let drug of dialogForm.controls.drugs?.value; let i = index; trackBy:trackBy">
                    <tr class="table-row" [formGroupName]="i">
                        <td class="text-left drug" >
                            <div class="heading">
                                {{drug?.friendlyName}} 
                            </div>
                            <div class="secondary flex">
                                {{drug?.packageNdc}}
                                <div class="flex space-x-2">
                                    <app-badge *ngIf="dupTransactionsService.isDup(drug?.drugId, drug?.inventoryLocationId)" 
                                        [color]="BadgeColorsEnum.Red" class="ml-2">
                                        Potential Dup
                                    </app-badge>
                                </div>
                            </div>
                        </td>
                        <td class="location" *ngIf="inventoryLocationsEnabled$ | async"> 
                            <app-inventory-locations-dropdown
                                [formControl]="dialogForm.controls.drugs.at(i).get('inventoryLocationId')"
                                (optionChosen)="locationChosen($event, drug?.drugId)"
                                [excludeOptions]="excludedLocations || getLocationsToExcludeWhichAlreadySelectedForTheDropdown(i)"
                                [positiveInventoryBalanceLocationIDs]="inventoryLocationsService.getPositiveInventoryBalanceLocationIDs(drug?.drugId)"
                            ></app-inventory-locations-dropdown>
                        </td>
                        <td class="text-right starting">{{drug?.onHand | number}}</td>
                        <td class="!pl-2 count">
                            <app-input
                                class="block"
                                formControlName="addedQuantity"
                                [type]="'number'"
                                customClasses="-mr-64"
                                [showErrors]="false"
                                textAlign="right"
                                #addedQuantityInput
                                (keyupEnter)="onCountInputKeyDown(i)"
                                (keydownTab)="onCountInputKeyDown(i)"
                            ></app-input>
                        </td>

                        <td class="text-right on-hand">
                            {{drug?.endingQuantity | number}}
                            <app-back-count-not-resolved-tooltip *ngIf="backCountService.isDrugRequiresBackCount(drug?.drugId)"
                             [locationID]="drug?.inventoryLocationId"
                             [drugID]="drug?.drugId"
                            ></app-back-count-not-resolved-tooltip>
                        </td>
                        <td class="text-right on-hand">
                            {{drug?.availableSOH | number}}
                        </td>
                        <!-- Reserve space if any requires back-count-->
                        <td class="text-left back-count" *ngIf="backCountService.isAnyRequiresBackCount()">
                            <app-yes-no-toggle [hidden]="!backCountService.isDrugRequiresBackCount(drug?.drugId)"
                             [control]="dialogForm.controls.drugs.at(i).get('isBackCountMatches')"
                            ></app-yes-no-toggle>
                        </td>
                        
    
                        <td class="controls">
                         <div class="flex space-x-5">
                            <app-add-note class="block cursor-pointer z-10"
                            [friendlyName]="drug?.friendlyName"
                            [note]="drug?.note"
                            (deleted)="removeNote(i)"
                            (submitted)="saveAddedNote($event, i)"></app-add-note>

                            <img *ngIf="withDeleteDrugFeature()"
                                class="delete-icon" src="assets/icons/icon-basket.svg" alt="delete" 
                                (click)="deleteRow(i)"/>
                         </div>
                        </td>
                    </tr>
                    </ng-container>
                </tbody>
            </table>

            <app-error-message *ngIf="quantityViolatedError()">
                {{maxValueExceededErrorMessage}}
            </app-error-message>
            
            <ng-content></ng-content>
            <div *ngIf="withAddDrugFeature()"
            class="flex justify-between mt-4">
                <button class="add-new-drug disabled:opacity-60"  
                    [disabled]="dialogForm.controls.drugs?.invalid"
                    (click)="onAddNewDrugClick()"
                >+ Add Split Fill NDC
                </button>
                <div class="text-[#0369A1] self-end	" *ngIf="dialogForm.controls.drugs?.length > 1">Total count:
                    <span class="text-[#13425a] font-medium">{{getAddedQtyTotal()}}</span>
                </div>
            </div>
        </div>
        <div class="dialog-controls-default !border-t-0 !pt-0">
            <app-button customClasses="px-4"
                        text="Cancel"
                        [minWidth]="0"
                        subStyle="transparent"
                        class="cancel-btn"
                        (clicked)="close()"
                        (keydownTab)="focusFirstInput()"
                        #closeButton
            ></app-button>
            <app-button customClasses="px-4"
                        [text]="getSubmitBtnText()"
                        class="save-btn"
                        type="submit"
                        (keydownTab)="focusFirstInput()"
                        #submitButton
            ></app-button>
        </div>
    </form>
</app-dialog>

<app-dup-transactions-dialog *ngIf="showDupeDispenseModal$ | async" (cancel)="close()" (save)="review()"></app-dup-transactions-dialog>